document.addEventListener("DOMContentLoaded", function () {
  // Trouver toutes les images avec class="swatch image"
  const swatchImages = document.querySelectorAll(".swatch.image");

  swatchImages.forEach(img => {
    img.style.cursor = "zoom-in";
    img.addEventListener("click", function () {
      const overlay = document.createElement("div");
      overlay.style.position = "fixed";
      overlay.style.top = "0";
      overlay.style.left = "0";
      overlay.style.width = "100vw";
      overlay.style.height = "100vh";
      overlay.style.backgroundColor = "rgba(0,0,0,0.8)";
      overlay.style.display = "flex";
      overlay.style.justifyContent = "center";
      overlay.style.alignItems = "center";
      overlay.style.cursor = "zoom-out";
      overlay.style.zIndex = "9999";

      const zoomedImg = document.createElement("img");
      zoomedImg.src = img.src;
      zoomedImg.style.maxWidth = "90%";
      zoomedImg.style.maxHeight = "90%";
      zoomedImg.style.borderRadius = "10px";
      zoomedImg.style.boxShadow = "0 0 15px rgba(0,0,0,0.5)";
      overlay.appendChild(zoomedImg);

      overlay.addEventListener("click", function () {
        document.body.removeChild(overlay);
      });

      document.body.appendChild(overlay);
    });
  });
});